import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Box, Divider } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import { Button } from "./styles";
import { Card } from "../Card";
import { ArrowChevronDown, ArrowChevronUp } from "../Icons";
function getHeight(height) {
  switch (height) {
    case 'sm':
      return 80;
    case 'md':
      return 400;
    case 'lg':
      return 720;
  }
  throw new Error('Invalid height!');
}
export function ShowMore(_ref) {
  var _ref$cardProps = _ref.cardProps,
    cardProps = _ref$cardProps === void 0 ? {} : _ref$cardProps,
    children = _ref.children,
    maxHeight = _ref.maxHeight,
    startExpanded = _ref.startExpanded,
    onToggleOpen = _ref.onToggleOpen;
  var maxHeightPx = getHeight(maxHeight);
  var defaultContainerStyle = {
    maxHeight: "".concat(maxHeightPx, "px"),
    overflowY: 'hidden'
  };
  var containerRef = useRef(null);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isToggleVisible = _useState2[0],
    setToggleVisibility = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setIsExpanded = _useState4[1];
  var _useState5 = useState(defaultContainerStyle),
    _useState6 = _slicedToArray(_useState5, 2),
    containerStyle = _useState6[0],
    setContainerStyle = _useState6[1];
  var handleHeightChange = function handleHeightChange(node) {
    if (!(node !== null && node !== void 0 && node.current)) {
      return;
    }
    var doesContentOverflow = node.current.scrollHeight > maxHeightPx;
    setToggleVisibility(doesContentOverflow);
  };
  var toggleOpen = function toggleOpen() {
    var oldState = isExpanded;
    var newState = !oldState;
    setIsExpanded(newState);
    if (newState) {
      setContainerStyle({});
    } else {
      setContainerStyle(defaultContainerStyle);
    }
    if (onToggleOpen) {
      onToggleOpen(oldState, newState);
    }
  };
  useEffect(function () {
    if (!(containerRef !== null && containerRef !== void 0 && containerRef.current)) {
      return;
    }
    handleHeightChange(containerRef);
    var onResize = function onResize() {
      return handleHeightChange(containerRef);
    };
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [!!(containerRef !== null && containerRef !== void 0 && containerRef.current), handleHeightChange]);
  useEffect(function () {
    if (startExpanded) {
      toggleOpen();
    }
  }, []);
  return /*#__PURE__*/React.createElement(Card, cardProps, /*#__PURE__*/React.createElement(Box, {
    ref: containerRef,
    style: containerStyle,
    mb: 3
  }, children), isToggleVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    display: {
      xs: 'none',
      md: 'block'
    }
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    disableFocusRipple: false,
    endIcon: isExpanded ? /*#__PURE__*/React.createElement(ArrowChevronUp, null) : /*#__PURE__*/React.createElement(ArrowChevronDown, null),
    onClick: toggleOpen,
    variant: "text"
  }, "Show ", isExpanded ? 'Less' : 'More'))));
}